import sort from 'array-sort';
import PubSub from 'pubsub-js';
import editSensorModal from '../../components/edit-sensor-modal';
import getSensorById from '../../scripts/get-sensor-by-id';
import getSensorReadings from '../../scripts/get-sensor-readings';
import prettyDateSelect from '../../scripts/pretty-date-select'
import downloadReadings from '../../scripts/download-readings';
import getSensors from '../../scripts/get-sensors';
import datepicker from '../../components/js-datepicker';
import moment from 'moment';
import noSensorsOverlay from '../../components/no-sensors-overlay'
import CacheInstance from '../../components/cache'
import Sidebar_TS from './sidebar/sidebar_ts'
import Sidebar_EX from './sidebar/sidebar_ex'
import Sidebar_US from './sidebar/sidebar_us'
import ReadingCharts from './charts/reading-charts'
import DashboardCurrentReadings from './current-readings'
import defaultSensorDisplayDatapoints from '../../util/default-sensor-display-datapoints'
import Branding from '../../components/branding'

class DashboardLite {

  constructor () {

    this.$container = $('.dashboard__container');
    this.initContainer();
    this.chartsContainer = this.$container.find(".dashboard-lite__charts")[0];
    this.ReadingCharts = new ReadingCharts(this.chartsContainer);

    this.$currentReadingsContainer = this.$container.find('.dashboard-lite__current-readings');
    this.DashboardCurrentReadings = new DashboardCurrentReadings(this.$currentReadingsContainer);

    // charts
    this.$noReadings = this.$container.find('.dashboard-lite__chart__no-readings');

    // date select
    this.$dateSelect = this.$container.find('[name="readings_date_range"]');
    this.$customDateSelect = this.$container.find('.dashboard-lite__readings-date-range__custom');
    this.$customDateSelectError = this.$container.find('.dashboard-lite__readings-date-range__custom__error');
    this.$customDateSelectButton = this.$container.find('.dashboard-lite__readings-date-range__custom__button button');
    this.$dateSelectStart = this.$container.find('.custom-date-range-start');
    this.$dateSelectEnd = this.$container.find('.custom-date-range-end');
    this.dateSelectStart = null;
    this.dateSelectEnd = null;

    this.updateDateSelect();

    this.$sidebar = this.$container.find('.dashboard-lite__sidebar');

    this.$sensorSelect = this.$container.find('.dashboard-lite__sensor-select');
    this.$downloadCsvButton = this.$container.find('.dashboard-lite__download-sensor-readings');
    this.$downloadCsvRange = this.$container.find('.dashboard-lite__chart-heading__download-date-range');

    this.currentSensor = null;
    this.currentSensorId = null;
    this.currentReadings = null;

    const url = new URL(window.location);

    // select parameter sensor first
    // else use the last viewed sensor

    if(url.searchParams.get('id')) {
      this.currentSensorId = url.searchParams.get('id');
    } else {
      this.currentSensorId = window.localStorage.getItem('last-viewed-sensor');
    }

    this.sensors = [];
    this.sensorsMap = {};
    this.activeSensors = [];
    this.inactiveSensors = [];

    this.doAutoUpdate = true;
    this.updateIntervalTime = Date.now();
    this.updateIntervalTiming = 60000;

    // pause and resume the update interval based on whether we're looking at the window
    $(window).on('blur', () => {
      this.doAutoUpdate = false;
    });

    $(window).on('focus', () => {

      this.doAutoUpdate = true;

      if(Date.now() - this.updateIntervalTime > this.updateIntervalTiming) {
        this.updateSensorsInterval();
      }

    });

    this.getSensorData().then(() => {

      const items = [];

      if(this.activeSensors.length > 0) {

        this.activeSensors.forEach(sensor => {

          items.push({
            value: sensor.sensor_id,
            label: sensor.sensor_name,
            active: 1,
          });

        });
      }

      if(this.inactiveSensors.length > 0) {

        this.inactiveSensors.forEach(sensor => {

          items.push({
            value: sensor.sensor_id,
            label: sensor.sensor_name,
            active: 0,
          });

        });

      }

      if(items.length > 0) {

        this.$sensorSelect.html(`
        ${items.map((item, i) => {
          return `
          <option value="${item.value}" ${item.value == this.currentSensorId ? 'selected' : ''}>${item.label}${!item.active ? ' (Offline)' : ''}</option>
          `
        }).join("\n")}
        `);

        this.$sensorSelect.on('change', () => {
          this.selectSensor(this.$sensorSelect.val());
        });

        this.$sensorSelect.trigger('change');

      } else {

        // no sensors
        this.$sensorSelect.html('<option value="">No available sensors</option>');

      }

      this.init();

    });

  }

  init() {

    if(this.sensors.length > 0) {
      this.renderSidebar();
      this.initEvents();

      // update sensors every minute
      setInterval(this.updateSensorsInterval.bind(this), this.updateIntervalTiming);

    } else {

      // render no sensors overlay
      noSensorsOverlay(this.$container);

    }

  }

  updateSensorsInterval() {

    // only auto update when the window is focused
    if(!this.doAutoUpdate) return;

    if(Date.now() - this.updateIntervalTime < 30000) {
      return;
    }

    this.updateIntervalTime = Date.now();

    this.getSensorData().then(() => {

      // check to see if the active sensor updated
      this.sensors.forEach(sensor => {
        if(sensor.sensor_id === this.currentSensorId) {

          const dateOption = this.$dateSelect.val();

          if([
            '24_hours',
            'today',
            'this_week',
            '7_days',
            'this_month',
            '30_days',
          ].includes(dateOption)) {

            if(this.currentSensorLastCheckin && this.currentSensorLastCheckin !== sensor.last_checkin) {

              this.renderSensor(sensor);
              this.loadSensorReadings(sensor.sensor_id);

            }
          }

        }
      });

      // update date select range for current time values
      this.updateDateSelect();

      // update sidebar
      this.renderSidebar(true);

    });

  }

  selectSensor(sensor_id) {

    if(sensor_id) {

      Branding.maybeUpdateBranding(sensor_id)

      getSensorById(sensor_id).then(sensor => {

        this.currentSensor = sensor;
        this.currentSensorId = sensor.sensor_id;

        window.localStorage.setItem('last-viewed-sensor', this.currentSensorId);

        this.$sidebar.find(`.sidebar-sensor`).toggleClass('is-active', false);
        this.$sidebar.find(`.sidebar-sensor[data-for="${sensor_id}"]`).toggleClass('is-active', true);

        this.renderSensor(sensor);
        this.ReadingCharts.render(sensor);
        this.loadSensorReadings(sensor.sensor_id);

      });
    }

  }

  renderSensor(sensor) {

    this.currentSensorLastCheckin = sensor.last_checkin;
    this.DashboardCurrentReadings.render(this.currentSensor);

    this.$container.find('.dashboard-lite__sensor-name-value').html(sensor.sensor_name);

    if(window.site.isApp) {
      this.$downloadCsvButton.hide();
    }

    this.$downloadCsvButton.attr('disabled', true);

  }

  loadSensorReadings(sensorId) {

    if(!sensorId) {
      return;
    }

    const options = {};
    const rangeSelection = this.$dateSelect.val();

    if(rangeSelection === 'custom') {
      options.start = this.$dateSelectStart.val();
      options.end = this.$dateSelectEnd.val();
      this.$customDateSelectError.toggleClass('is-active', false);
    }

    getSensorReadings(sensorId, rangeSelection, options).then(readings => {

      this.DashboardCurrentReadings.update(this.currentSensor, readings);

      if(readings.error && readings.error === true) {
        if(rangeSelection === 'custom') {

          // show custom error message
          this.$customDateSelectError.toggleClass('is-active', true);
          this.$customDateSelectError.html(readings.message);

        } else {
          // janky error
          alert(readings.message);
        }

        return;
      }

      this.currentReadings = readings;

      if(readings) {

        this.$downloadCsvRange.html(`
          <span class="show-for-large">Range:</span> 
          ${window.getUserTimezoneDate(readings.start).format('MM/DD/YY')}
          &ndash;
          ${window.getUserTimezoneDate(readings.end).format('MM/DD/YY')}
        `);

        this.$noReadings.toggleClass('is-active', false);

        this.$downloadCsvButton.attr('disabled', false);

      } else {

        this.$downloadCsvRange.html(``);

        this.$noReadings.toggleClass('is-active', true);

        this.$downloadCsvButton.attr('disabled', true);

      }

    });

  }

  getSensorData() {
    return new Promise((resolve, reject) => {

      getSensors().then(sensors => {

        this.activeSensors = [];
        this.inactiveSensors = [];

        this.sensors = sensors;
        this.sensors = sort(this.sensors, 'name', {});

        this.sensors.forEach((sensor, i) => {

          sensor.checkedIn = false;

          const lastCheckinTime = window.datetimeToDate(sensor.last_checkin).getTime();
          const lastCheckinSeconds = (Date.now() - lastCheckinTime) / 1000;

          // fix when we get the sensor before the system updates the sensor online
          if(lastCheckinSeconds < sensor.send_interval) {
            sensor.offline = 0;
          }

          // check if the sensor checked in since we last checked
          if(this.sensorsMap[sensor.id]) {
            if(lastCheckinTime > window.datetimeToDate(this.sensorsMap[sensor.id].last_checkin).getTime()) {
              sensor.checkedIn = true;
            }
          }

          this.sensorsMap[sensor.id] = sensor;

          if(sensor.offline == 0) {
            this.activeSensors.push(sensor);
          } else {
            this.inactiveSensors.push(sensor);
          }

          // update current sensor
          if(
            this.currentSensor &&
            sensor.id === this.currentSensor.id
          ) {
            this.currentSensor = sensor;
            console.log("currentSensor", sensor);
          }

        });

        this.activeSensors = sort(this.activeSensors, 'sensor_name', {});
        this.inactiveSensors = sort(this.inactiveSensors, 'sensor_name', {});

        resolve();

      });

    });

  }

  /**
   * Update the labels of the date select to show date ranges
   */
  updateDateSelect() {
    prettyDateSelect(this.$dateSelect);
  }

  initContainer() {

    const cachedDefaultDateRange = CacheInstance.get('readings-date-range');
    let defaultDateRange = '24_hours';

    if(cachedDefaultDateRange && cachedDefaultDateRange.value) {
      defaultDateRange = cachedDefaultDateRange.value;
    }

    this.$container.html(`
    <div class="dashboard-lite">
      <div class="dashboard-lite__sensor-container">
        <div class="dashboard-lite__settings">
          <div class="dashboard-lite__settings__option">
            <label>
              Sensor:
            </label>
            <select name="sensor_select" class="dashboard-lite__sensor-select">
                <option value="">Loading...</option>
              </select>
          </div>
          <div class="dashboard-lite__settings__option">
            <label>
              Date Range:
              <select name="readings_date_range" class="dashboard-lite__readings-date-range">
                <option value="24_hours" ${defaultDateRange === '24_hours' ? 'selected' : ''}>Last 24 Hours</option>
                <option value="today" ${defaultDateRange === 'today' ? 'selected' : ''}>Today</option>
                <option value="6_hours" ${defaultDateRange === '6_hours' ? 'selected' : ''}>Last 6 Hours</option>
                <option value="12_hours" ${defaultDateRange === '12_hours' ? 'selected' : ''}>Last 12 Hours</option>
                <option value="yesterday" ${defaultDateRange === 'yesterday' ? 'selected' : ''}>Yesterday</option>
                <option value="this_week" ${defaultDateRange === 'this_week' ? 'selected' : ''}>This Week (Sun - Today)</option>
                <option value="7_days" ${defaultDateRange === '7_days' ? 'selected' : ''}>Last 7 Days</option>
                <option value="last_week" ${defaultDateRange === 'last_week' ? 'selected' : ''}>Last Week (Sun - Sat)</option>
                <option value="this_month" ${defaultDateRange === 'this_month' ? 'selected' : ''}>This Month</option>
                <option value="30_days" ${defaultDateRange === '30_days' ? 'selected' : ''}>Last 30 Days</option>
                <option value="last_month" ${defaultDateRange === 'last_month' ? 'selected' : ''}>Last Month</option>
                <option value="three_months" ${defaultDateRange === 'three_months' ? 'selected' : ''}>Last Three Months</option>
                <option value="custom" ${defaultDateRange === 'custom' ? 'selected' : ''}>Custom</option>
              </select>
            </label>   
          </div>
          
          <div class="dashboard-lite__readings-date-range__custom">
            <div class="dashboard-lite__readings-date-range__custom__start">
              <label for="custom-date-range-start">Start Date</label>
              <input type="text" id="custom-date-range-start" class="custom-date-range-start" value="${moment().format('MM/DD/YYYY')}" /> 
            </div>
            <div class="dashboard-lite__readings-date-range__custom__end">
              <label for="custom-date-range-end">End Date</label>
              <input type="text" id="custom-date-range-end" class="custom-date-range-end" value="${moment().format('MM/DD/YYYY')}" /> 
            </div>
            <div class="dashboard-lite__readings-date-range__custom__button">
              <button class="button button--medium">Apply</button>
            </div>
            <div class="dashboard-lite__readings-date-range__custom__error">This is an error</div>
            
          </div>
            
        </div>
        
        <div class="dashboard-lite__current-readings"></div>
        
        <div class="dashboard-lite__charts"></div>
        <div class="dashboard-lite__charts-offline-message">Readings highlighted in grey were collected by the sensor while offline</div>
        </div>
        <div class="dashboard-lite__sidebar"></div>
    </div>
  </div>
  `);

  }

  renderActiveSensorForSidebar(sensor, update = false) {

    const nextCheckinStr = window.getPrettyNextCheckin(sensor.next_checkin);

    const selectedSensorDisplayDatapoints =
      (window.currentUser && window.currentUser.sensor_display_datapoints) ?
        JSON.parse(window.currentUser.sensor_display_datapoints) : defaultSensorDisplayDatapoints

    // show all probe temps if enabled
    if(selectedSensorDisplayDatapoints.includes("probe_temp")) {
      selectedSensorDisplayDatapoints.push("probe_temp2")
    }

    let sidebarTemplate = null;

    switch (sensor.type) {
      case("EX"):
        sidebarTemplate = Sidebar_EX;
        break;
      case("US"):
        sidebarTemplate = Sidebar_US;
        break;
      default:
        sidebarTemplate = Sidebar_TS;
        break;
    }

    // Initializing when the sensor has no values set
    if(sensor.last_temp == 0 && sensor.last_humidity == 0 && sensor.last_voltage == 0) {

      return `
      <div class="sidebar-sensor sidebar-sensor--active ${this.currentSensorId == sensor.sensor_id ? 'is-active' : ''}" data-for="${sensor.sensor_id}">
          
        <div class="sidebar-sensor__name">
          <span class="text--smaller">ID: </span>
          ${sensor.sensor_name}
        </div>
        
        <div class="sidebar-sensor__content">
            
          <div class="sidebar-sensor__details" style="width:100%;">             
            <div class="sidebar-sensor__status">
              <div class="sidebar-sensor__status__label">Status</div>
              <div class="sidebar-sensor__status__value">
                <div class="sidebar-sensor__status__offline">
                  Initializing
                  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" style="width:10px; display: inline-block;">
                    <circle cx="10" cy="10" r="10" fill="#f8da1c" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="sidebar-sensor__status">
              <div class="sidebar-sensor__status__value">
                This is a new sensor; allow up to 2 minutes before new readings start showing.
              </div>
            </div>
          </div>
        
        </div>
      </div>  
      `
    }

    return `
    <div class="sidebar-sensor sidebar-sensor--active ${this.currentSensorId == sensor.sensor_id ? 'is-active' : ''}" data-for="${sensor.sensor_id}">
          
      <div class="sidebar-sensor__name">
        <span class="text--smaller">ID: </span>
        ${sensor.sensor_name}
      </div>
      
      <div class="sidebar-sensor__content">
        
        <div class="sidebar-sensor__details">             
          <div class="sidebar-sensor__status">
            <div class="sidebar-sensor__status__label">Status</div>
            <div class="sidebar-sensor__status__value">
              <div class="sidebar-sensor__status__online">
                Online
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" style="width:10px; display: inline-block;">
                  <circle cx="10" cy="10" r="10" fill="#94bd46" />
                </svg>
              </div>
            </div>
          </div>
          <div class="sidebar-sensor__status">
            <div class="sidebar-sensor__status__label">Last Reading</div>
            <div class="sidebar-sensor__status__value ${update && sensor.checkedIn ? 'animate' : ''}">
              <span class="value-wrapper">${window.getUserTimezoneDate(sensor.last_checkin).format('MMM DD, YYYY h:mm a')}</span>
            </div>
          </div>
          <div class="sidebar-sensor__status">
            <div class="sidebar-sensor__status__label">Next Reading</div>
            <div class="sidebar-sensor__status__value ${update ? 'animate' : ''}">
              <span class="value-wrapper">${nextCheckinStr}</span>
            </div>
          </div>
        </div>
        
        <div class="sidebar-sensor__stats ${update && sensor.checkedIn ? 'animate' : ''}">
          <span class="value-wrapper">${sidebarTemplate.render(sensor, selectedSensorDisplayDatapoints)}</span>
        </div>
      
      </div>
      
    </div>
    `
  }

  renderSidebar(update = false) {

    // don't render the sidebar if the user has no sensors
    if(this.sensors.length === 0) {
      return;
    }

    let html = '';

    html += `
      <h3><i class="fas fa-wifi"></i> My Sensors</h3>
      <div class="sidebar-sensors">`;

    if(this.activeSensors.length > 0) {

      this.activeSensors.forEach(sensor => {
        html += this.renderActiveSensorForSidebar(sensor, update);
      });

    }

    if(this.inactiveSensors.length > 0) {

      this.inactiveSensors.forEach(sensor => {

        const last_checkin = window.getUserTimezoneDate(sensor.last_checkin);
        let last_checkin_str = '&ndash;';

        if(last_checkin !== false) {
          last_checkin_str = last_checkin.format('MMM DD, YYYY h:mm a');
        }

        html += `
        <div class="sidebar-sensor sidebar-sensor--offline ${this.currentSensorId == sensor.sensor_id ? 'is-active' : ''}" data-for="${sensor.sensor_id}">
          
          <div class="sidebar-sensor__name">
            <span class="text--smaller">ID: </span>
            ${sensor.sensor_name}
          </div>
          
          <div class="sidebar-sensor__content">
            
            <div class="sidebar-sensor__details">             
              <div class="sidebar-sensor__status">
                <div class="sidebar-sensor__status__label">Status</div>
                <div class="sidebar-sensor__status__value">
                  <div class="sidebar-sensor__status__offline">
                    Offline
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" style="width:10px; display: inline-block;">
                      <circle cx="10" cy="10" r="10" fill="#da1301" />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="sidebar-sensor__status">
                <div class="sidebar-sensor__status__label">Last Reading</div>
                <div class="sidebar-sensor__status__value">
                  ${last_checkin_str}
                </div>
              </div>
            </div>
          
          </div>
          
        </div>
        `;

      });

    }

    html += '</div>';

    this.$sidebar.html(html);

    if(update) {

      setTimeout(() => {
        this.$sidebar.find('.animate').each((i, el) => {
          $(el).removeClass('animate');
        });
      }, 400);

    }

    this.$sidebar.find('.sidebar-sensor').on('click', e => {
      this.$sensorSelect.val($(e.currentTarget).data('for'));
      this.$sensorSelect.trigger('change');
    });

  }

  initEvents() {

    this.$customDateSelectButton.on('click', () => {
      this.loadSensorReadings(this.currentSensorId);
    });

    this.$dateSelect.on('change', () => {

      const value = this.$dateSelect.val();

      // don't remember expensive ranges
      if(value !== 'three_months' && value !== 'custom') {
        CacheInstance.save('readings-date-range', value);
      } else {
        CacheInstance.remove('readings-date-range');
      }

      this.updateDateSelect();

      if(value !== 'custom') {

        this.loadSensorReadings(this.currentSensorId);
        this.$customDateSelect.toggleClass('is-active', false);

      } else {

        this.$customDateSelect.toggleClass('is-active', true);

        if(!this.dateSelectStart) {

          this.dateSelectStart = datepicker(this.$dateSelectStart[0], {
            id: 'custom-range',
            formatter: (input, date, instance) => {
              input.value = moment(date).format('MM/DD/YYYY');
            },
          });

          this.dateSelectEnd = datepicker(this.$dateSelectEnd[0], {
            id: 'custom-range',
            formatter: (input, date, instance) => {
              input.value = moment(date).format('MM/DD/YYYY');
            },
            position: 'br',
          });

        }
      }

    });

    PubSub.subscribe('sensors/updated', (msg, sensor) => {

      if(this.currentSensorId) {
        this.selectSensor(this.currentSensorId);
      }

    });

    this.$downloadCsvButton.on('click', () => {

      this.$downloadCsvButton.attr('disabled', true);

      downloadReadings(this.$dateSelect.val(), this.currentSensor, this.currentReadings).then(() => {
        this.$downloadCsvButton.attr('disabled', false);
      });

    });

    this.$container.on('click', '.dashboard-lite__sensor-settings-button', () => {

      if(this.currentSensorId) {
        new editSensorModal(this.currentSensorId);
      }

    });

  }

}

export default DashboardLite;
